import { render } from "./TimeTableClass.vue?vue&type=template&id=5c23f34d"
import script from "./TimeTableClass.vue?vue&type=script&lang=js"
export * from "./TimeTableClass.vue?vue&type=script&lang=js"

import "./TimeTableClass.vue?vue&type=style&index=0&id=5c23f34d&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__